import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { PageService } from "../shared";

@Component({
  selector: "page-list",
  templateUrl: "./page-list.component.html",
  styleUrls: ["./page-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class PageListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: PageService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Páginas - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/pages/page-list/page-list.component.ts